import React from 'react'
import { useTranslation } from 'react-i18next'

import { useChecklistForm, useChecklistFormActions } from '../../_form/ChecklistFormHandler'
import { FlexCol } from '../../../../../components/structure/FlexGrid'
import FormItem from '../../../../../components/form/FormItem'
import SectionsSeparator from './SectionsSeparator'
import UsagePicker from '../UsagePicker'

const UsageSection = () => {
  const form = useChecklistForm()
  const { handleChange } = useChecklistFormActions()
  const { t } = useTranslation('editChecklist')

  const commonProps = { handleChange, form, t }

  return (
    <>
      <FlexCol paddingGutter={1} width="100%">
        <FormItem label={t('fieldsStep.usages')} field="usages" {...commonProps}>
          <UsagePicker value={form.usages} onChange={handleChange('usages')} />
        </FormItem>
      </FlexCol>
      <SectionsSeparator />
    </>
  )
}

export default UsageSection
